export const TYPES_FILTERS = [
  { label: 'Atendente', value: 'attendant' },
  { label: 'Data de encerramento', value: 'closing_date' }
];
